import { combineReducers } from '@reduxjs/toolkit';
// import { combineReducers } from 'redux';
import { itemsReducer } from './items';
import { fetchReducer } from './fetch';
import { orderReducer } from './order';
import { getAuthReducer } from './auth';
import { socketReducer } from '../wsAll/reducer';
import { socketUserReducer } from '../wsUser/reducer';

export * from './items';
export * from './fetch';
export * from './order';
export * from './auth';

export const rootReducer = combineReducers({
    items: itemsReducer,
    order: orderReducer,
    fetch: fetchReducer,
    auth: getAuthReducer,
    socket: socketReducer,
    socketUser: socketUserReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
